import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Universities} from "./universities";


const routes: Routes = [
  {
    path: 'tutors',
    component: Universities,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UniversitiesRoutingModule {}
